// extracted by mini-css-extract-plugin
module.exports = {"container":"EnterRecord_container_32WaA","title_tips":"EnterRecord_title_tips_1vC7T","table_actions":"EnterRecord_table_actions_kFqGB","btn":"EnterRecord_btn_o2CO3"};